import { hasCapability, type User } from "../base";

export const mcp = {
  bid_read: (user: User) => hasCapability(user, "mcp.bid.read"),
  estimate_read: (user: User) => hasCapability(user, "mcp.estimate.read"),
  execute_sql_query: (user: User) => hasCapability(user, "mcp.execute_sql_query"),
  oauth_access: (user: User) => hasCapability(user, "mcp.oauth.access"),
  query_quickbooks: (user: User) => hasCapability(user, "mcp.query_quickbooks"),
};
